import { useImageReadUrl } from "../hooks/useImageReadUrl";

/**
 * Component to display images that may be R2 keys or direct URLs
 */
export function SubmissionImage({
  src,
  submissionId,
  titleId,
  alt,
  className,
}: Readonly<{
  src: string;
  submissionId?: string | null;
  titleId?: string | null;
  alt: string;
  className?: string;
}>) {
  const isR2Key = src.startsWith("r2://");
  const r2Key = isR2Key ? src.replace("r2://", "") : null;

  const { readUrl, loading, error } = useImageReadUrl({
    submissionId,
    titleId,
    key: r2Key,
    mode: titleId ? "title" : "submission",
  });

  if (isR2Key && loading) {
    return (
      <div className={`flex items-center justify-center bg-neutral-800/50 ${className ?? ""}`}>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
      </div>
    );
  }

  if (isR2Key && error) {
    return (
      <div className={`flex items-center justify-center bg-neutral-800/50 ${className ?? ""}`}>
        <p className="text-red-500 text-sm">Failed to load image</p>
      </div>
    );
  }

  const imageUrl = isR2Key ? readUrl : src;
  if (!imageUrl) return null;

  return <img src={imageUrl} alt={alt} className={className} />;
}
